import {
  CREATECHANNELPARTNERPAYOUT,
  GETCHANNELPARTNERPAYOUT,
  UPDATECHANNELPARTNERPAYOUT,
  DELETECHANNELPARTNERPAYOUT,
  axios,
  baseURL,
  ServiceURL
} from "./types";

export const createChannelPrtnerPayout = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: ServiceURL + "/api/hospitalpayments/createpayouts",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECHANNELPARTNERPAYOUT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};





export const getChannelPrtnerPayout = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/hospitalpayments/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHANNELPARTNERPAYOUT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateChannelPrtnerPayout = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/hospitalpayments/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATECHANNELPARTNERPAYOUT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteChannelPrtnerPayout = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/hospitalpayments/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETECHANNELPARTNERPAYOUT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

